import { render, staticRenderFns } from "./GeneratePurchaseOrderModal.vue?vue&type=template&id=b60908a8&scoped=true"
import script from "./GeneratePurchaseOrderModal.vue?vue&type=script&lang=ts"
export * from "./GeneratePurchaseOrderModal.vue?vue&type=script&lang=ts"
import style0 from "./GeneratePurchaseOrderModal.vue?vue&type=style&index=0&id=b60908a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60908a8",
  null
  
)

export default component.exports